export const calculateNetFromGross = (gross, insuranceSalary) => {
  const empShare = insuranceSalary * 0.11;
  const netSalaryBeforeTaxes = gross - empShare;
  const annualSalaryBefore = netSalaryBeforeTaxes * 12;

  const annualSubmittedSalaryAfterTaxes =
    annualSalaryBefore <= 20000 ? 0 : annualSalaryBefore - 20000;

  let annualTaxes = 0;
  if (annualSubmittedSalaryAfterTaxes <= 40000) {
    annualTaxes = 0;
  } else if (annualSubmittedSalaryAfterTaxes <= 55000) {
    annualTaxes = (annualSubmittedSalaryAfterTaxes - 40000) * 0.1;
  } else if (annualSubmittedSalaryAfterTaxes <= 70000) {
    annualTaxes = (annualSubmittedSalaryAfterTaxes - 55000) * 0.15 + 1500;
  } else if (annualSubmittedSalaryAfterTaxes <= 200000) {
    annualTaxes = (annualSubmittedSalaryAfterTaxes - 70000) * 0.2 + 1500 + 2250;
  } else if (annualSubmittedSalaryAfterTaxes <= 400000) {
    annualTaxes =
      (annualSubmittedSalaryAfterTaxes - 200000) * 0.225 + 1500 + 2250 + 26000;
  } else if (annualSubmittedSalaryAfterTaxes <= 600000) {
    annualTaxes =
      (annualSubmittedSalaryAfterTaxes - 400000) * 0.25 +
      1500 +
      2250 +
      26000 +
      45000;
  } else if (annualSubmittedSalaryAfterTaxes > 1200000) {
    annualTaxes = (annualSubmittedSalaryAfterTaxes - 1200000) * 0.275 + 300000;
  }

  const monthlySalaryTax = annualTaxes / 12;
  const martyrsFund = gross * 0.0005;
  const netSalary = netSalaryBeforeTaxes - (monthlySalaryTax + martyrsFund);

  return {
    netSalary,
    monthlyTax: monthlySalaryTax,
    martyrsFund,
    employeeInsuranceShare: empShare,
  };
};

export const calculateGrossFromNet = (targetNet, insuranceSalary) => {
  let low = targetNet;
  let high = targetNet * 3;
  const tolerance = 0.01;
  const maxIterations = 200;

  for (let i = 0; i < maxIterations; i++) {
    const mid = (low + high) / 2;
    const { netSalary } = calculateNetFromGross(mid, insuranceSalary);
    const difference = netSalary - targetNet;

    if (Math.abs(difference) < tolerance) {
      return mid;
    }

    if (netSalary < targetNet) {
      low = mid;
    } else {
      high = mid;
    }
  }

  return (low + high) / 2;
};


export const buildCalculatedValues = (netSalaryFromStorage, insuranceSalaryFromStorage) => {
  if (netSalaryFromStorage <= 0) return null;

  const grossSalary   = calculateGrossFromNet(netSalaryFromStorage, insuranceSalaryFromStorage);
  const calculations  = calculateNetFromGross(grossSalary, insuranceSalaryFromStorage);

  return {
    insuranceSalary:  insuranceSalaryFromStorage,
    socialInsurance:  calculations.employeeInsuranceShare,
    employerInsurance: insuranceSalaryFromStorage * 0.1875,
  };
};